import React, { useEffect, Fragment } from 'react'
import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import backend from '../services/backend'
import WaitingModal from '../components/Modals/waitingModal/WaitingModal'
import AlertModal from '../components/Modals/alertModal/AlertModal'
import constants from '../constants'

const AdminRoute = ({ component: Component }) => {
    const [error, setError] = useState()
    const [isWaitingModalOpen, setIsWaitingModalOpen] = useState(true)
    const [role, setRole] = useState()
    const [loading, setLoading] = useState(true)
    
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const usersMe = await backend.getUsersMe(sessionStorage.getItem(constants.GC_TOKEN))
                setRole(usersMe.user.role.value)
            } catch (error) {
                setError(`An error occured while fetching data:${JSON.stringify(error.message)}`)
                console.log(error)
            } finally {
                setIsWaitingModalOpen(false)
                setLoading(false)
            }
        }
        fetchUser()
    }, [])

    if (loading) {
        return (
            <Fragment>
                <WaitingModal
                    isOpen={isWaitingModalOpen}
                    header='Loading user profile'
                />
                <AlertModal
                    isOpen={!!error}
                    header='Error'
                    toggle={() => { setError(undefined) }}
                    body={error}
                />
            </Fragment>
        )
    }

    // In React Router v6, we return components directly rather than using the render prop
    return (
        <Fragment>
            <AlertModal
                isOpen={!!error}
                header='Error'
                toggle={() => { setError(undefined) }}
                body={error}
            />
            {(sessionStorage.getItem(constants.GC_TOKEN) && role === 'admin') 
                ? <Component role={role} /> 
                : <Navigate to="/unauthorized" replace />
            }
        </Fragment>
    )
}

export default AdminRoute